import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import React from 'react';
import { sidebarWidth } from '../processingPreprocess/processingPreprocess.styles';

export const titleBoxStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '40px',
  flex: '0 0 auto'
};

export const titleStyles: React.CSSProperties = {
  fontSize: '16px',
  fontWeight: '700',
  color: '#3D4047',
  paddingTop: '20px',
  paddingLeft: '20px',
  fontFamily: 'Circular Std Book'
};

export const closeIconStyles: SxProps<Theme> = {
  position: 'absolute',
  width: '19px',
  height: '19px',
  color: '#76787F',
  right: '19px',
  top: '19px'
};

export const middleBlockStyles: React.CSSProperties = {
  height: '150px',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  flex: '1'
};

export const buttonsStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  flex: '0 0 auto',
  marginBottom: '20px'
};

export const discardButtonStyles: React.CSSProperties = {
  width: '180px',
  height: '36px',
  backgroundColor: '#B3B5B9',
  color: '#ffffff',
  fontFamily: 'Circular Std Book',
  fontSize: '16px',
  fontWeight: '450px',
  borderRadius: '8px',
  marginRight: '28px',
  border: 'none',
  cursor: 'pointer'
};

export const discardButtonEnableStyles: React.CSSProperties = {
  width: '180px',
  height: '36px',
  backgroundColor: '#334063',
  color: '#ffffff',
  fontFamily: 'Circular Std Book',
  fontSize: '16px',
  fontWeight: '450px',
  borderRadius: '8px',
  marginRight: '28px',
  border: 'none',
  cursor: 'pointer'
};

export const saveButtonStyles = (isDisabled: boolean): React.CSSProperties => {
  return {
    width: '180px',
    height: '36px',
    backgroundColor: !isDisabled ? '#B3B5B9' : '#334063',
    color: '#ffffff',
    fontFamily: 'Circular Std Book',
    fontSize: '16px',
    fontWeight: '450px',
    borderRadius: '8px',
    border: 'none',
    cursor: !isDisabled ? 'default' : 'pointer'
  };
};

export const boxStyles = (open: boolean): SxProps<Theme> => {
  return {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    alignSelf: 'flex-start',
    right: 0,
    width: sidebarWidth,
    height: '100%',
    backgroundColor: 'white',
    border: '1px solid grey',
    borderRadius: '7px 0 0 7px',
    boxShadow: 3,
    zIndex: 10,
    padding: 0,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  };
};
